import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";

export class CustomService extends BaseService {  
}
